<template>
    <div class="form-check form-check-inline p-0 m-0">
        <label
            class="border badge d-inline-block fw-600 m-1 p-1 ps-4 tag-gacetilla"
        >
            <input
                type="checkbox"
                class="form-check-input"
                :value="inputValue"
                v-model="model"
            />
            {{label}}
        </label>
    </div>
</template>

<script>
export default {
    name: "TagCheckbox",
    props: {
        label: String,
        value: Array,
        inputValue: [Number, String],
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
};
</script>
